module.exports = __webpack_public_path__ + "img/bg_大师等级@2x.895dd592.png";